"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCatalog = void 0;
const Routes = [
    { path: '/:reseller', exact: true },
    { path: '/:reseller/menu', exact: true },
    { path: '/:reseller/pronta-entrega', exact: false },
    { path: '/:reseller/search', exact: false },
    { path: '/:reseller/shopping-cart', exact: false },
    { path: '/:reseller/categoria', exact: false },
    { path: '/:reseller/categorias', exact: true },
    { path: '/:reseller/produtos-em-destaque', exact: true },
    { path: '/:reseller/produto/:productId', exact: true },
    { path: '/:reseller/marca', exact: false },
    { path: '/:reseller/marcas', exact: false },
    { path: '/:reseller', exact: true },
];
const isCatalog = (path, resellerSlug) => {
    if (!resellerSlug) {
        return false;
    }
    return Routes.some((route) => {
        const routeHelper = route.path.replace('/:reseller', '').replace('/:productId', '');
        // Verifica se o path recebido pela função bate com o path da route da iteração atual
        // Se sim, substitui por /helper para dar match na regEx
        let pathHelper = '';
        if (routeHelper === '') {
            pathHelper = path.replace(/\/$/g, '').replace(`/${resellerSlug}`, '/slug').concat('/helper');
        }
        else {
            pathHelper = path
                .replace(/\/$/g, '')
                .replace(`/${resellerSlug}`, '/slug')
                .replace(routeHelper, '/helper');
        }
        return pathHelper.match(/\/slug\/helper(\/(\w|-)*)*/g) !== null;
    });
};
exports.isCatalog = isCatalog;
